import { Navigate } from "react-router-dom";
import { MainLayout } from "../main-layout/MainLayout";
import { Loader } from "../loader";

interface Props {
  to: string;
  replace?: boolean;
}

export const BetterNavigate = ({ to, replace }: Props) => {
  return (
    <MainLayout>
      <Loader />
      <Navigate to={to} replace={replace} />
    </MainLayout>
  );
};
